export const PREV_EXAM_DUE_DATE = 'prev-exam-due-date'
export const PREV_EXAM_START_DATE = 'prev-exam-start-date'
